import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Actions, CampusClient } from '@datacamp/exercise-contract';
import React from 'react';
export class ExerciseContract extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      exerciseProps: undefined
    });
    _defineProperty(this, "campusClient", new CampusClient({
      channelName: this.props.type,
      listenElement: window,
      postElement: window
    }));
    _defineProperty(this, "listenToProps", exerciseProps => {
      this.setState({
        exerciseProps
      });
    });
  }
  componentDidMount() {
    var _this$props$initialEx;
    this.campusClient.on(Actions.SET_EXERCISE_PROPS, this.listenToProps);
    this.campusClient.onClientIsReady({});
    this.setState({
      exerciseProps: (_this$props$initialEx = this.props.initialExerciseProps) !== null && _this$props$initialEx !== void 0 ? _this$props$initialEx : undefined
    });
  }
  componentWillUnmount() {
    this.campusClient.off(Actions.SET_EXERCISE_PROPS, this.listenToProps);
  }
  render() {
    const {
      exerciseProps
    } = this.state;
    return this.props.children({
      callbacks: {
        onExerciseFinished: this.campusClient.onExerciseFinished.bind(this.campusClient),
        onExerciseReady: this.campusClient.onExerciseIsReady.bind(this.campusClient),
        onExerciseStatusUpdate: this.campusClient.onExerciseStatusUpdate.bind(this.campusClient),
        onExerciseSubmitted: this.campusClient.onExerciseSubmitted.bind(this.campusClient),
        onXpUpdated: this.campusClient.onXpUpdated.bind(this.campusClient)
      },
      exerciseProps
    });
  }
}